import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectConfig } from '../../../../../shared/ui/form/select/select.component.config';
import { Option } from '../../../../../shared/models/option.model';

@Component({
    selector: 'app-contact-general-form',
    templateUrl: './contact-general-form.component.html',
    styleUrls: ['./contact-general-form.component.css'],
    standalone: false
})
export class ContactGeneralFormComponent implements OnInit {
    form!: UntypedFormGroup;

    formConfiguration: any = {
        streetType: {
            label: 'Tipo de Vía',
            placeholder: 'Selecciona tipo de Vía',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        address: {
            label: 'Dirección',
            placeholder: 'Introduce tu dirección'
        },
        number: {
            label: 'Número',
            placeholder: 'Introduce tu número'
        },
        block: {
            label: 'Bloque',
            placeholder: 'Introduce tu bloque'
        },
        entrance: {
            label: 'Portal',
            placeholder: 'Introduce tu portal'
        },
        staircase: {
            label: 'Escalera',
            placeholder: 'Introduce tu escalera'
        },
        floor: {
            label: 'Piso',
            placeholder: 'Introduce tu piso'
        },
        door: {
            label: 'Puerta',
            placeholder: 'Introduce tu puerta'
        },
        countriesCode: {
            label: 'Páis',
            placeholder: 'Selecciona país',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        provinceCode: {
            label: 'Provincia',
            placeholder: 'Selecciona provincia',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        municipalityCode: {
            label: 'Municipio',
            placeholder: 'Selecciona municipio',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        postalCode: {
            label: 'Código postal',
            placeholder: 'Introduce código postal'
        },
        email: {
            label: 'Código postal',
            placeholder: 'Introduce email'
        },
        residenceTypeId: {
            label: 'Tipo de Residencia',
            placeholder: 'Selecciona tipo de residencia',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        bankAccount: {
            label: 'Cuenta Bancaria',
            placeholder: 'Introduce cuenta bancaria'
        },
        bic: {
            label: 'BIC',
            placeholder: 'Selecciona BIC',
            multiple: false,
            loadOptions: () => this.loadStreetTypes()
        },
        phone: {
            label: 'Teléfono de contacto',
            placeholder: 'Introduce teléfono de contacto'
        },
        contactPerson: {
            label: 'Persona de contacto',
            placeholder: 'Introduce persona de contacto'
        },
        taxRepresentativeNIF: {
            label: 'NIF Representante a efecto fiscal',
            placeholder: 'Introduce NIF representante a efecto fiscal'
        },
        isPhysical: {
            id: 'isPhysical',
            label: 'Persona física',
            placeholder: 'Persona física',
        },
        isJuridical: {
            id: 'isJuridical',
            label: 'Persona jurídica',
            placeholder: 'Persona jurídica',
        },
        isPublicAdmin: {
            id: 'isPublicAdmin',
            label: 'Administración pública',
            placeholder: 'Administración pública',
        },
        isDirect: {
            id: 'isDirect',
            label: 'Conexión directa',
            placeholder: 'Conexión directa',
        },
    }


    constructor(private fb: UntypedFormBuilder) { }

    ngOnInit(): void {
        this.form = this.fb.group({
            isPhysical: [false, Validators.required],
            isJuridical: [false, Validators.required],
            isPublicAdmin: [false, Validators.required],
            isDirect: [false, Validators.required],
            streetTypeId: [null, Validators.required],
            address: [null, Validators.required],
            number: [null, Validators.required],
            block: [null, Validators.required],
            entrance: [null, Validators.required],
            staircase: [null, Validators.required],
            floor: [null, Validators.required],
            door: [null, Validators.required],
            countriesCode: [null, Validators.required],
            provinceCode: [null, Validators.required],
            municipalityCode: [null, Validators.required],
            postalCode: [null, Validators.required],
            email: [null, Validators.required],
            residenceTypeId: [null, Validators.required],
            bankAccount: [null, Validators.required],
            bic: [null, Validators.required],
            phone: [null, Validators.required],
            contactPerson: [null, Validators.required],
            taxRepresentativeNIF: [null, Validators.required],
        });

        // this.form.get('provincia')!.valueChanges.subscribe(value => {
        //     this.onProvinciaChange();
        // });

    }

    onSubmit(): void {
        if (this.form.valid) {
        } else {
            this.markAllControlsAsTouched(this.form);
        }
    }

    markAllControlsAsTouched(formGroup: UntypedFormGroup): void {
        Object.keys(formGroup.controls).forEach(controlName => {
            const control = formGroup.get(controlName);
            if (control instanceof UntypedFormGroup) {
                this.markAllControlsAsTouched(control);
            } else {
                control!.markAsTouched();
            }
        });
    }

    loadStreetTypes(): Option[] {
        return [
            { value: '08', label: 'Barcelona' },
            { value: '28', label: 'Madrid' }
        ];
    }

    provinciaConfig: SelectConfig = {
        label: 'Provincia',
        placeholder: 'Selecciona provincia',
        multiple: false,
        loadOptions: () => this.loadProvincias()
    };

    municipioConfig: SelectConfig = {
        label: 'Municipio',
        placeholder: 'Selecciona municipio',
        multiple: false,
        loadOptions: () => this.loadMunicipios(this.form.get('provincia')!.value)
    };

    loadProvincias(): Option[] {
        return [
            { value: '08', label: 'Barcelona' },
            { value: '28', label: 'Madrid' }
        ];
    }

    loadMunicipios(provincia: string): Option[] {
        if (provincia === '08') {
            return [
                { value: '08019', label: 'Barcelona' },
                { value: '08101', label: 'L\'Hospitalet' }
            ];
        } else if (provincia === '28') {
            return [
                { value: '28079', label: 'Madrid' },
                { value: '28123', label: 'Getafe' }
            ];
        }
        return [];
    }

    onProvinciaChange(): void {
        const provincia = this.form.get('provincia')!.value;
        this.municipioConfig = {
            ...this.municipioConfig,
            key: Date.now(), // clave única que cambia en cada llamada
            loadOptions: () => this.loadMunicipios(provincia)
        };

        this.form.get('municipio')!.reset();
    }
}
